export default __webpack_public_path__ + "static/media/close2.982e1f15.svg";